var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TextHTML',{attrs:{"custom-class":_vm.customClass,"html":_vm.html,"renderComponents":_vm.renderAttachments}})
}
var staticRenderFns = []

export { render, staticRenderFns }